__turbopack_context__.v({
  "carouselNav": "home-featured-testimonials-module-scss-module__VWRMHG__carouselNav",
  "contentTextAnimate": "home-featured-testimonials-module-scss-module__VWRMHG__contentTextAnimate",
  "homeFeaturedTestimonialFade": "home-featured-testimonials-module-scss-module__VWRMHG__homeFeaturedTestimonialFade",
  "imageButton": "home-featured-testimonials-module-scss-module__VWRMHG__imageButton",
  "imageColumn": "home-featured-testimonials-module-scss-module__VWRMHG__imageColumn",
  "navBtn": "home-featured-testimonials-module-scss-module__VWRMHG__navBtn",
  "navIcon": "home-featured-testimonials-module-scss-module__VWRMHG__navIcon",
  "playCircle": "home-featured-testimonials-module-scss-module__VWRMHG__playCircle",
  "playOverlay": "home-featured-testimonials-module-scss-module__VWRMHG__playOverlay",
  "playTriangle": "home-featured-testimonials-module-scss-module__VWRMHG__playTriangle",
  "root": "home-featured-testimonials-module-scss-module__VWRMHG__root",
  "staticImage": "home-featured-testimonials-module-scss-module__VWRMHG__staticImage",
  "wistiaPlayer": "home-featured-testimonials-module-scss-module__VWRMHG__wistiaPlayer",
  "wistiaWrap": "home-featured-testimonials-module-scss-module__VWRMHG__wistiaWrap",
});
